// extracted by mini-css-extract-plugin
export default {"skeletWrapper":"Skelet_skeletWrapper--TnT","skelet":"Skelet_skelet--pKt","skeletShimmer":"Skelet_skeletShimmer--nog","skeletBlock":"Skelet_skeletBlock--ioP"};